import { create } from "zustand"

import type { ChatSlice } from "./slices/chat-slice"

import { createChatSlice } from "./slices/chat-slice"
import { createNamespacedStore } from "./store-factory"

type AITranslatorStore = ChatSlice

function createAITranslatorStoreInstance() {
  return create<AITranslatorStore>()((set, get, api) => ({
    ...createChatSlice(set, get, api),
  }))
}

/**
 * Hook to get AI Translator store isolated by sessionType.
 *
 * @param sessionType - Session type identifier
 * @returns Zustand store hook for the specific sessionType
 */
export function useAITranslatorStore(sessionType: string) {
  return createNamespacedStore("ai-translator", sessionType, createAITranslatorStoreInstance)
}
